export default __webpack_public_path__ + "static/media/loading.7b6697ab.svg";